/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.RoleToAccountResponse = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The RoleToAccountResponse model module.
   * @module model/RoleToAccountResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>RoleToAccountResponse</code>.
   * A response object for the account role.
   * @alias module:model/RoleToAccountResponse
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>RoleToAccountResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RoleToAccountResponse} obj Optional instance to populate.
   * @return {module:model/RoleToAccountResponse} The populated <code>RoleToAccountResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('accountId')) {
        obj['accountId'] = ApiClient.convertToType(data['accountId'], 'String');
      }
      if (data.hasOwnProperty('roleName')) {
        obj['roleName'] = ApiClient.convertToType(data['roleName'], 'String');
      }
      if (data.hasOwnProperty('roleId')) {
        obj['roleId'] = ApiClient.convertToType(data['roleId'], 'String');
      }
      if (data.hasOwnProperty('expiration')) {
        obj['expiration'] = ApiClient.convertToType(data['expiration'], 'Date');
      }
      if (data.hasOwnProperty('isExpired')) {
        obj['isExpired'] = ApiClient.convertToType(data['isExpired'], 'Boolean');
      }
      if (data.hasOwnProperty('warningMessage')) {
        obj['warningMessage'] = ApiClient.convertToType(data['warningMessage'], 'String');
      }
    }
    return obj;
  }

  /**
   * The ID of the user account.
   * @member {String} accountId
   */
  exports.prototype['accountId'] = undefined;
  /**
   * The role name.
   * @member {String} roleName
   */
  exports.prototype['roleName'] = undefined;
  /**
   * The ID of the role.
   * @member {String} roleId
   */
  exports.prototype['roleId'] = undefined;
  /**
   * The expiration of the account role. If no value set means the account role will never expire.
   * @member {Date} expiration
   */
  exports.prototype['expiration'] = undefined;
  /**
   * Indicating if the account role has expired.
   * @member {Boolean} isExpired
   */
  exports.prototype['isExpired'] = undefined;
  /**
   * The warning message for the account role if any.
   * @member {String} warningMessage
   */
  exports.prototype['warningMessage'] = undefined;



  return exports;
}));



